<!--
 * @Author: Nie Wie
 * @Date: 2020-02-21 14:01:51
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-03-26 17:17:06
 * @Description: 观测时报--新增数据趋势模块
 -->
<template>
  <div class="observe-trend" >
    <total-add></total-add>
    <every-satellite></every-satellite>
  </div>
</template>

<script>
import TotalAdd from './total-add'
import EverySatellite from './every-satellite'

export default {
  components: {
    TotalAdd,
    EverySatellite,
  },
}
</script>

<style lang="scss">
</style>
